import { euro, fmtDate, num, type AgentProposalField } from '@immoaktas/shared';
import { inputNum } from '../../lib/format';
import { DateInput, MoneyInput, TextInput, parseDecimalInput } from '../../ui';

export type FieldValue = string | number | boolean | null;

/** A field of a proposal as text (cents as euro, dates German, numbers with up to 3 decimals). */
export function showField(f: AgentProposalField, t: (k: string) => string): string {
  if (f.value === null || f.value === '') return t('agent.proposal.empty');
  if (f.type === 'cents' && typeof f.value === 'number') return euro(f.value);
  if (f.type === 'date' && typeof f.value === 'string') return fmtDate(f.value);
  if (f.type === 'number' && typeof f.value === 'number') return num(f.value, 3);
  if (f.type === 'boolean') return f.value ? t('agent.proposal.yes') : t('agent.proposal.no');
  return String(f.value);
}

/** Editor for one field, by its type (the server coerces and validates again). */
export function FieldInput({ f, value, onChange }: { f: AgentProposalField; value: FieldValue | undefined; onChange: (v: FieldValue) => void }) {
  const current = value === undefined ? f.value : value;
  if (f.type === 'cents') return <MoneyInput label={f.label} labelHidden valueCents={typeof current === 'number' ? current : null} onChange={(c) => onChange(c)} />;
  if (f.type === 'date') return <DateInput label={f.label} labelHidden value={typeof current === 'string' ? current : ''} onChange={(e) => onChange(e.target.value || null)} />;
  if (f.type === 'number')
    return <TextInput label={f.label} labelHidden inputMode="decimal" defaultValue={typeof current === 'number' ? inputNum(current) : ''} onChange={(e) => onChange(parseDecimalInput(e.target.value))} />;
  if (f.type === 'boolean') return <input type="checkbox" aria-label={f.label} checked={current === true} onChange={(e) => onChange(e.target.checked)} />;
  return <TextInput label={f.label} labelHidden value={typeof current === 'string' ? current : ''} onChange={(e) => onChange(e.target.value)} />;
}
